import { render, staticRenderFns } from "./loginDialog.vue?vue&type=template&id=6a31c747&scoped=true&"
import script from "./loginDialog.vue?vue&type=script&lang=js&"
export * from "./loginDialog.vue?vue&type=script&lang=js&"
import style0 from "./loginDialog.vue?vue&type=style&index=0&id=6a31c747&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a31c747",
  null
  
)

export default component.exports